// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VideoTestim.css */

.video-wrapper {
  position: relative;
  cursor: pointer;
}

.video-thumbnail {
  width: 100%;
}

.play-overlay {
  position: absolute;
  height: 50px;
  width: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  cursor: pointer;
  background: #0ab7fd;
  border-radius: 50%;
}
.play-overlay svg {
  position: absolute;
  height: 50px;
  width: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  height: 30px;
  padding: 5px;
}

.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.video-player {
  position: relative;
  width: 80%;
  max-width: 800px;
}
.video-player .close-button {
  padding: 5px 15px;
  border-radius: 25px;
  margin-top: 55px;
  font-size: 1rem;
}

.video-player video {
  width: 100%;
}

.close-button {
  padding: 0px;
  margin: 0px;
  position: absolute;
  top: -50px;
  right: 10px;
  background: none;
  border: none;
  font-size: 2em;
  color: #fff;
  cursor: pointer;
}
.video-wrapper img {
  padding: 30px;
  height: 270px;
}

.vt-heading {
  color: var(--dPink);
}

.video-testim-carousel .owl-dots {
  /* margin-top: -20px; */
}

@media screen and (max-width: 1024px) {
  .video-wrapper img {
    height: 230px;
    width: auto !important;
  }
}

/* @media (max-width: 576px) {
  .video-wrapper img {
    height: 230px;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/component/common/video-testimonial/VideoTestim.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;;;;GAIG","sourcesContent":["/* VideoTestim.css */\n\n.video-wrapper {\n  position: relative;\n  cursor: pointer;\n}\n\n.video-thumbnail {\n  width: 100%;\n}\n\n.play-overlay {\n  position: absolute;\n  height: 50px;\n  width: 50px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #fff;\n  cursor: pointer;\n  background: #0ab7fd;\n  border-radius: 50%;\n}\n.play-overlay svg {\n  position: absolute;\n  height: 50px;\n  width: 50px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #fff;\n  height: 30px;\n  padding: 5px;\n}\n\n.video-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.video-player {\n  position: relative;\n  width: 80%;\n  max-width: 800px;\n}\n.video-player .close-button {\n  padding: 5px 15px;\n  border-radius: 25px;\n  margin-top: 55px;\n  font-size: 1rem;\n}\n\n.video-player video {\n  width: 100%;\n}\n\n.close-button {\n  padding: 0px;\n  margin: 0px;\n  position: absolute;\n  top: -50px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 2em;\n  color: #fff;\n  cursor: pointer;\n}\n.video-wrapper img {\n  padding: 30px;\n  height: 270px;\n}\n\n.vt-heading {\n  color: var(--dPink);\n}\n\n.video-testim-carousel .owl-dots {\n  /* margin-top: -20px; */\n}\n\n@media screen and (max-width: 1024px) {\n  .video-wrapper img {\n    height: 230px;\n    width: auto !important;\n  }\n}\n\n/* @media (max-width: 576px) {\n  .video-wrapper img {\n    height: 230px;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
